<template>
  <div class="container py-3">
    <h4 class="mb-2">Admin: Danh sách phiếu công (Mock)</h4>

    <div class="card p-3 mb-3">
      <div class="d-flex gap-2 flex-wrap align-items-end">
        <div>
          <label class="small text-muted">Tháng</label>
          <input v-model="month" type="month" class="form-control" style="width: 160px" />
        </div>
        <div>
          <label class="small text-muted">Trạng thái</label>
          <select v-model="status" class="form-select" style="width: 160px">
            <option value="ALL">ALL</option>
            <option value="DRAFT">DRAFT</option>
            <option value="PUBLISHED">PUBLISHED</option>
            <option value="SIGNED">SIGNED</option>
            <option value="VERIFIED">VERIFIED</option>
            <option value="REJECTED">REJECTED</option>
          </select>
        </div>
        <div>
          <label class="small text-muted">Từ khóa</label>
          <input v-model="keyword" class="form-control" placeholder="Tên NV..." style="width: 220px" />
        </div>

        <button class="btn btn-outline-primary" @click="load" :disabled="store.loading">
          Tải
        </button>
      </div>
    </div>

    <div v-if="store.error" class="alert alert-danger">{{ store.error }}</div>
    <div v-if="store.loading" class="alert alert-info">Đang tải...</div>

    <div class="table-responsive">
      <table class="table table-bordered align-middle">
        <thead class="table-light">
          <tr>
            <th>NV</th>
            <th>Phòng</th>
            <th>Công</th>
            <th>Status</th>
            <th>SignedAt</th>
            <th width="180">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="p in store.adminList" :key="p.id">
            <td>{{ p.hoTen }}</td>
            <td>{{ p.phongBan }}</td>
            <td><b>{{ p.totalCong }}</b></td>
            <td><span class="badge bg-secondary">{{ p.status }}</span></td>
            <td class="small text-muted">{{ p.signedAt || "-" }}</td>
            <td>
              <router-link class="btn btn-sm btn-primary" :to="`/admin/phieu-cong/${p.id}`">
                Xem
              </router-link>
            </td>
          </tr>
          <tr v-if="!store.adminList.length">
            <td colspan="6" class="text-center text-muted">Không có dữ liệu</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { usePhieuCongStore } from "@/stores/phieuCongStore";

const store = usePhieuCongStore();
const month = ref("2025-12");
const status = ref("ALL");
const keyword = ref("");

function load() {
  store.fetchAdminList(month.value, status.value, keyword.value);
}

onMounted(load);
</script>
